<template>
    <div name="review" class="review">
        <div class="container">
            <div class="section-header">
                <strong class="title">이용 후기</strong>
            </div>

            <div class="tab-container">
                <div
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="{ 'active': activeTab === index }"
                    @click="changeTab(index)"
                    class="tab"
                >
                    {{ tab }}
                </div>
            </div>

            <div class="content-container">
                <div v-show="activeTab === 0" class="content">
                    <ul class="card-list">
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review1.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>어머님 모시고 병원 갈 때마다 연차 쓰고
                                    1시간 이상 병원에서 대기했는데 대기 없이
                                    진료 볼 수 있어서 너무 편합니다.</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">보호자</span><strong class="name">김OO님</strong>
                                    <span class="info">42, 서울 강동구</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review2.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>깜깜이 수면제 처방 등이 걱정되었는데,
                                    제 카카오톡으로 처방, 결제, 복약안내까지
                                    실시간으로 확인할 수 있어 안심이에요</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">보호자</span><strong class="name">송OO님</strong>
                                    <span class="info">54, 경기 수원시</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review3.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>부모님 병원 방문에 할애할 시간이 많이 줄 어들어서 삶의 질이 높아졌어요. 복용약에 대해서도 확인이 용이해서 좋습니다.</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">보호자</span><strong class="name">박OO님</strong>
                                    <span class="info">44, 경기 성남시</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-show="activeTab === 1" class="content">
                    <ul class="card-list">
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review4.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>원장님을 편하게 만나 진료받을 수 있어서 좋습니다. 항상 친절하고 상세하게 물어봐 주셔서 무척 감동했어요</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">어르신</span><strong class="name">최OO님</strong>
                                    <span class="info">76, 경남 창원시</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review5.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>매번 이전 진료 이후 경과를 꼼꼼히 물어봐 주시고 기록해주십니다. 자막으로도 진료 내용을 확인할 수 있어 편리합니다</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">어르신</span><strong class="name">김OO님</strong>
                                    <span class="info">68, 인천 미추홀구</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review6.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>날씨에 구애받지 않고 병원을 방문할 수 있어 무척 편리합니다. 항상 친절하고 상세한 진료에 대면 못지 않게 만족스럽습니다</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">어르신</span><strong class="name">김OO님</strong>
                                    <span class="info">70, 서울 중랑구</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-show="activeTab === 2" class="content">
                    <ul class="card-list">
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review7.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>보호자분들의 만족도가 굉장히 높습니다.
                                    어르신 모시고 병원 방문하던 일들이 없어지며 효율이 증가합니다</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">센터장</span><strong class="name">조OO님</strong>
                                    <span class="info">43, 서울 중랑구</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review8.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>신규 상담 오신 보호자분들께서 높은 관심을 보이십니다. 급한 성사, 변비도 진료 보고 약을 받아 볼 수 있어 매우 만족합니다</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">센터장</span><strong class="name">이OO님</strong>
                                    <span class="info">50, 경기 성남시</span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <img class="img-reviewer" src="../../assets/mobile_barocare/img_review9.png" alt="이용자 이미지">
                            <div class="cont">
                                <p>기존 보호자 분들의 반응이 아주 좋습니다.
                                    센터에서 병원 방문 일정을 해결해주고 내역을 조회할 수 있어 안심하실 수 있습니다.</p>
                                <div class="info-reviewer">
                                    <span class="reviewer">센터장</span><strong class="name">김OO님</strong>
                                    <span class="info">54, 서울 중랑구</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'review',
    data() {
        return {
            tabs: ['보호자', '어르신', '센터'],
            contents: [  ],
            activeTab: 0,
        };
    },
    mounted() {
    },
    methods: {
        changeTab(index) {
            this.activeTab = index;
        },
    },
}
</script>

<style scoped>
    .review{
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #fff;
    }
    .review .container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-height: 900px;
        margin: 0 auto;
        padding: 145px 20px 80px;
        z-index: 1;
    }
    .section-header{
        width: 100%;
        text-align: center;
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 32px;
        font-weight: 600;
        line-height: 1.6;
        color: #1A1A1A;
    }

    .tab-container{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 28px;
    }
    .tab{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 82px;
        height: 36px;
        border-radius: 40px;
        border: 1px solid #999;;
        font-weight: 400;
        font-size: 16px;
        line-height: 1;
        color: #999;
        cursor: pointer;
    }
    .tab.active{
        border: 2px solid #2092EE;
        background: #FFF;
        font-weight: 600;
        line-height: 1;
        color: #2092EE;
    }
    .card-list{
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        margin-top: 30px;
        padding: 0;
        animation: fadeInUp1 2s;
    }
    .card-list li{
        display: flex;
        flex-direction: row;
        gap: 16px;
        width: 100%;
        /* min-height: 164px; */
        min-height: 130px;
        padding: 24px 17px ;
        background: #fff;
        border: 1px solid #CCC;
        border-radius: 10px;
    }
    .img-reviewer{
        width: 58px;
        height: 58px;
    }
    .cont{
        display: flex;
        flex-direction: column;
        /* justify-content: space-between; */
        width: calc(100% - 74px);
        font-size: 16px;
        font-family: 'Pretendard';
        font-weight: 400;
        line-height: 1.6;
        color: #1A1A1A;
    }
    .cont p{
        margin-bottom: 8px;
    }

    .info-reviewer{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .reviewer{
        font-weight: 600;
        color: #0082EC;
    }
    .name{
        padding:0 7px;
    }
    .info{
        position: relative;
        padding-left: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #999;
    }
    .info:before{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        content: '';
        display: block;
        width: 1px;
        height: 12.5px;
        background: #999;
    }   
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Review.vue